var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nl"},[_c('div',{staticClass:"nl-head"},[_c('fa-icon',{attrs:{"icon":"quote-left"}}),_vm._v(" "),_c('strong',[_vm._v("Resumo em linguagem natural")])],1),(_vm.resumo)?_c('div',{staticClass:"nl-body"},[_vm._v(_vm._s(_vm.resumo))]):_c('div',{staticClass:"nl-empty"},[_vm._v("Adicione condições para visualizar o resumo.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }